import moment from "moment";
import { sto } from "../Context/InshData";

export const invoicePayTypes = [
  { id: -1, name: "all" },
  { id: 1, name: "cash" },
  { id: 2, name: "network" },
];
export const salesmanViewTypes = [
  { id: 0, name: "commission-with-tax" },
  { id: 1, name: "commission-with-profit" },
  { id: 2, name: "all" },
  { id: 3, name: "none" },
];
let today = new Date();

export const initialSearchObject = {
  PcIdIvPc: "",
  refno: "",
  isAdmin: sto.User_typei == 1,
  branch: { id: sto.branchi, name: "current-branch" },
  sales_emp: { id: -1, name: "current-user", emp: sto.empi },
  bill_no: "",
  customer: { id: -1, name: "all" },
  bank: { id: -1, name: "all" },
  cust_mobile: "",
  inv_type: { id: -1, name: "all" },
  pay_type: { id: -1, name: "all" },
  dateFrom: moment(today.setDate(today.getDate() - 1)).format("YYYY-MM-DD"),
  timeFrom: moment(new Date()).startOf("day").format("HH:mm"),
  dateTo: moment(today.setDate(today.getDate() + 1)).format("YYYY-MM-DD"),
  timeTo: moment(new Date()).endOf("day").format("HH:mm"),
};
